//@ts-ignore
import { ApiClient } from "../../../lib/ApiClient";
import { useGenericSWR } from "../../../lib/useGenericSWR";
import * as Yup from 'yup';
//@ts-ignore
import { ensureLuxonDateOnly } from "lib/Formatters";
//@ts-ignore
import { globalTranslator } from "lib/GlobalTranslator";

export const apiEndpoint = 'api/v1/admin/RateVersion';

let formIteration = 0;
const t = globalTranslator;

export interface RateVersion {
    id?: number;
    cepOrgId: number;
    rateClassId: number;
    rateClassName: string;
    name: string;
    description?: string;
    startDate: any;
    endDate: any;
}

const getRateVersionDefaultItem = (rateClassId?: number) => {
    formIteration = formIteration + 1;
    return {
        formIteration: "new" + formIteration,
        id: 0,
        rateClassId: rateClassId,
        name: '',
        description: '',
        startDate: ensureLuxonDateOnly(new Date()),
        endDate: ensureLuxonDateOnly(new Date()),
        createdBy: 'REACT_FE',
        updatedBy: 'REACT_FE',
    }
};

const rateVersionValidationSchema = Yup.object().shape({
    rateClassId: Yup.number()
        .required(t('Rate Class is required'))
        .min(1, t('Rate Class is required')),
    name: Yup.string()
        .required(t("Required"))
        .max(256, t('Max of 256 characters')),
    description: Yup.string()
        .max(1028, t('Max of 1028 characters')).nullable(),
    startDate: Yup.date()
        .required(t("Required"))
        .when('endDate', {
            is: (endDate: any) => {
                return endDate;
            },
            then: Yup.date()
                .max(
                    Yup.ref("endDate"),
                    t("Version start date must be less than end date")),
        }),
    endDate: Yup.date()
        .nullable(),
});

const apiClient = new ApiClient();
apiClient.getDefaultItem = () => getRateVersionDefaultItem();
apiClient.getObjectName = () => {
    return t('Rate Version');
};

const useRateVersion = (id: number, swrOptions = {}) => {
    return useGenericSWR(apiEndpoint + "/" + id, apiClient, { ...swrOptions });
};

const useRateVersions = (filter: any, swrOptions = {}) => {
    const params = new URLSearchParams();
    params.append('filter', JSON.stringify(filter));
    return useGenericSWR(apiEndpoint + "?" + params.toString(), apiClient, { ...swrOptions });
};

const saveRateVersion = (rateVersion: RateVersion) => {
    if (rateVersion.id === 0) {
        return insertRateVersion(rateVersion);
    }
    return updateRateVersion(rateVersion);
}
const insertRateVersion = (rateVersion: RateVersion) => {
    return apiClient.poster(apiEndpoint, rateVersion);
};

const updateRateVersion = (rateVersion: RateVersion) => {
    return apiClient.putter(apiEndpoint, rateVersion);
};

const deleteRateVersion = (rateVersion: RateVersion) => {
    return apiClient.deleter(apiEndpoint + "/" + rateVersion.id, "", false, null, true, t("Rate versions that have rate charges cannot be deleted."));
};

const duplicateRateVersion = (rateVersion: RateVersion) => {
    return apiClient.putter(apiEndpoint + "/duplicateVersion", rateVersion)
}

export {
    useRateVersion,
    useRateVersions,
    saveRateVersion,
    insertRateVersion,
    updateRateVersion,
    deleteRateVersion,
    duplicateRateVersion,
    rateVersionValidationSchema,
    getRateVersionDefaultItem,
};